import Head from 'next/head'
import { useRouter } from 'next/router'

const HOST = process.env.NEXT_PUBLIC_HOST

export const SEOHead: React.FC<{
  title?: string | number | null
  desc?: string | null
}> = ({ title: _title, desc: _desc }) => {
  const router = useRouter()

  const isHome = router.pathname === '/'

  const title =
    isHome || !_title ? '无界AI-人人都是艺术家' : `${_title} | 无界AI`

  const desc = _desc
    ? _desc
    : '无界AI，集prompt搜索、AI图库、AI创作、AI广场、词/图等为一体。提供一站式AI搜索-创作-交流-分享服务。'

  const path = HOST + router.asPath

  return (
    <Head>
      <title>{title}</title>
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="applicable-device" content="pc" />
      <meta name="description" content={desc} />
      {isHome && (
        <meta
          name="keywords"
          content="AI描述,描述词搜索,AI创作,prompt搜索,图库,社区,广场"
        />
      )}

      <meta property="og:title" content={title} />
      <meta property="og:url" content={path} />
      <meta
        property="og:image"
        content="https://cdn.wujiebantu.com/upload/8A9FBA86DE2EA52AC1A24BDC692FF171/1712129887561/FmNieqg-bOfiZ97cu2ZtoAmJdbp7.png"
      />
      <meta property="og:description" content={desc} />
      <link rel="canonical" href={path} />
      <link rel="dns-prefetch" href="//webcdn.wujieai.com" />
      <link rel="dns-prefetch" href="//cdn.wujiebantu.com" />
    </Head>
  )
}
